module.exports = __webpack_public_path__ + "media/honey-icons/slt2-6a7e315b.svg";